import * as Sentry from "@sentry/react";

import { ENV, SENTRY_DSN } from "@type/config";
import { EENV } from "constants/index";

if (ENV === EENV.PROD) {
  Sentry.init({
    dsn: SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    tracesSampleRate: 1.0,

    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Additional SDK configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: false,
      }),
      Sentry.captureConsoleIntegration({
        levels: ["error"],
      }),
    ],
  });
}
